{
  "title": "Chain Lightning",
  "source": "Player's Handbook",
  "levelAndSchool": "6th-level evocation",
  "level": 6,
  "castingTime": "1 action",
  "range": "150 feet",
  "components": "V, S, M (a bit of fur; a piece of amber, glass, or a crystal rod; and three silver pins)",
  "duration": "Instantaneous",
  "description": [
    "You create a bolt of lightning that arcs toward a target of your choice that you can see within range. Three bolts then leap from that target to as many as three other targets, each of which must be within 30 feet of the first target. A target can be a creature or an object and can be targeted by only one of the bolts.",
    "A target must make a Dexterity saving throw. The target takes 10d8 lightning damage on a failed save, or half as much on a successful one.",
    "At Higher Levels. When you cast this spell using a spell slot of 7th level or higher, one additional bolt leaps from the first target to another target for each slot level above 6th."
  ],
  "spellLists": ["sorcerer", "wizard"]
}
